// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container_Gkqdu","pages":"Pagination_pages_GmFqS","active":"Pagination_active_mw12u"};